<template>
  <section class="download-app-section">
    <div class="download-app" :class="{ 'is-small': small }">
      <div class="download-app-content">
        <h3>Baixe nosso Aplicativo</h3>
        <p>
          Acompanhe seu processo em tempo real pela linha do tempo e com os
          comentários de seu advogado. Envie e receba documentos de seu processo
          e se mantenha atualizado sobre seus direitos recebendo os conteúdos
          exclusivos de Diké, o portal informativo da Crivelli Advogados
          Associados. Baixe o aplicativo agora!
        </p>
        <div class="download-app-content-logos">
          <a
            href="https://play.google.com/store/apps/details?id=br.com.appfactory.crivelli"
            target="_blank"
            ><img
              title="Google Store"
              src="@/assets/img/svg/download_google_app.svg"
          /></a>
          <a
            href="https://apps.apple.com/br/app/crivelli-advogados/id1271369437"
            target="_blank"
            ><img
              title="Apple Store"
              src="@/assets/img/svg/download_apple_store.svg"
          /></a>
        </div>
      </div>
      <div class="download-app-image"></div>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    small: Boolean,
  },
};
</script>

<style>
</style>
